import { useInfiniteQuery } from '@tanstack/react-query';

import { useAppSelector, useGroupsFilterParams, usePodsTabsParams } from '@pkg/hooks';

import { Groups } from '@app/client';
import config from '@app/config';

import { getNextPageParam, groupsCacheKeys } from './utils';

export const PODS_SIDEBAR_FOLLOWING_CACHE_KEY = ['groups-siebar-following'];

/**
 * React Hook using React Query Infinite Query to call `/groups`.
 * Supports
 * - pagination
 * - TODO: sorting
 */

export const useGetGroups = () => {
    const { filtersExcDefault, filters } = useGroupsFilterParams();

    const cache = groupsCacheKeys.groups(filters);

    // Conditionally set polling
    const { enablePollingHome: isPollingEnabled } = useAppSelector((state) => state.featureFlags.features);
    const pollingInterval = config.pollingSecondsHome * 1000;

    return useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) =>
            Groups.callGetGroups({
                query: { spam: false, page: pageParam || 0, ...filtersExcDefault },
                settings: { signal },
            }),
        {
            retry: false,
            keepPreviousData: true,
            refetchInterval: (data, query) => (isPollingEnabled && data === query.state.data ? pollingInterval : false),
            getNextPageParam,
        },
    );
};

/**
    Duplicate of the above
 */

export const useGetPods = () => {
    const { filtersExcDefault, filters } = usePodsTabsParams();

    const cache = groupsCacheKeys.groups(filters);

    // Conditionally set polling
    const { enablePollingHome: isPollingEnabled } = useAppSelector((state) => state.featureFlags.features);
    const pollingInterval = config.pollingSecondsHome * 1000;

    return useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) =>
            Groups.callGetGroups({
                query: { spam: false, page: pageParam || 0, ...filtersExcDefault },
                settings: { signal },
            }),
        {
            retry: false,
            keepPreviousData: true,
            refetchInterval: (data, query) => (isPollingEnabled && data === query.state.data ? pollingInterval : false),
            getNextPageParam,
        },
    );
};

/**
 * Get current users followed groups for sidebar
 */

export const useGetGroupsFollowing = () => {
    return useInfiniteQuery(
        PODS_SIDEBAR_FOLLOWING_CACHE_KEY,
        ({ pageParam = 0, signal }) =>
            Groups.callGetGroups({
                query: { user_filter: true, limit: 10, page: pageParam || 0 },
                settings: { signal },
            }),
        {
            retry: false,
            keepPreviousData: true,
            getNextPageParam,
        },
    );
};
